<template>
  <div class="profile-wrapper emb-card pa-4">
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    </div>
    <h4>{{profileInfoSection.Profile_Info_Title}}</h4>
    <v-layout row wrap v-if="!isShow">
      <v-flex xs5 sm5 md6 lg6 xl6>
        <p>{{profileInfoSection.Username_Label}}</p>
      </v-flex>
      <v-flex xs6 sm4 md6 lg6 xl6>
        <p>{{useDetails.name}}</p>
      </v-flex>
      <!-- <v-flex xs5 sm5 md6 lg6 xl6>
        <p>{{profileInfoSection.Location_Label}}</p>
      </v-flex>
      <v-flex xs5 sm5 md5 lg5 xl5>
        <p>{{addressadd}}</p>
      </v-flex>
      <v-flex xs1 sm1 md1 lg1 xl1>
        <a href="#" @click="editaddress()">
          <v-btn icon>
            <v-icon class="black--text">create</v-icon>
          </v-btn>
        </a>
      </v-flex>-->
      <v-flex xs5 sm5 md6 xl6 lg6 v-if="!isShow">
        <p>{{profileInfoSection.Email_Label}}</p>
      </v-flex>
      <v-flex xs5 sm5 md5 lg5 xl5 v-if="!isShow && useDetails.email && !iseditMail">
        <p>{{useDetails.email}}</p>
      </v-flex>
      <v-flex
        xs5
        sm5
        md5
        lg5
        xl5
        v-if="((!useDetails.isEmailVerified && useDetails.email && iseditMail) || (!useDetails.isEmailVerified && !useDetails.email)) && !isShow  "
      >
        <v-text-field
          style="margin-top:-2rem"
          v-model="email"
          type="text"
          :placeholder="profileInfoSection.Email_Label"
        ></v-text-field>
      </v-flex>

      <v-flex
        xs2
        sm2
        md1
        lg1
        xl1
        v-if="!useDetails.isEmailVerified && !isShow && useDetails.email && !iseditMail"
      >
        <v-btn @click="edit('email')" icon>
          <!-- <v-icon class="black--text" v-tooltip="profileInfoSection.Not_Verify_Label">edit</v-icon> -->
          <v-icon class="red--text">close</v-icon>
          <v-icon class="black--text">edit</v-icon>
        </v-btn>
      </v-flex>
      <v-flex
        xs2
        sm2
        md1
        lg1
        xl1
        v-if="!useDetails.isEmailVerified && !isShow && (iseditMail || !useDetails.email)"
      >
        <v-btn @click="postVerify('email')" icon>
          <v-icon class="orange--text">send</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs2 sm2 md1 lg1 xl1 v-if="useDetails.isEmailVerified  && !isShow &&useDetails.email">
        <v-btn icon>
          <v-icon class="green--text">done_outline</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs5 sm5 md6 lg6 xl6 v-if="!isShow">
        <p>{{profileInfoSection.Mobile_Number__Label}}</p>
      </v-flex>
      <v-flex xs5 sm5 md5 lg5 xl5 v-if="!isShow && useDetails.phoneNumber && !iseditPhone">
        <p>{{useDetails.phoneNumber}}</p>
      </v-flex>
      <v-flex
        xs5
        sm5
        md5
        lg5
        xl5
        v-if="((!useDetails.isPhoneNumberVerified && useDetails.phoneNumber && iseditPhone) || (!useDetails.isPhoneNumberVerified && !useDetails.phoneNumber)) && !isShow  "
      >
        <v-text-field
          style="margin-top:-2rem"
          v-model="phone"
          type="text"
          :placeholder="profileInfoSection.Mobile_Number_Placeholder"
        ></v-text-field>
        <p>{{profileInfoSection.Please_Add_Phonenumber_with_country}}</p>
      </v-flex>
      <v-flex
        xs2
        sm2
        md1
        lg1
        xl1
        v-if="!useDetails.isPhoneNumberVerified && !isShow && useDetails.phoneNumber && !iseditPhone"
      >
        <v-btn @click="edit('phone')" icon>
          <!-- <v-icon class="black--text" :v-tooltip="profileInfoSection.Not_Verify_Label">edit</v-icon> -->
          <v-icon class="red--text">close</v-icon>
          <v-icon class="black--text">edit</v-icon>
        </v-btn>
      </v-flex>
      <v-flex
        xs2
        sm2
        md1
        lg1
        xl1
        v-if="!useDetails.isPhoneNumberVerified && !isShow && (iseditPhone || !useDetails.phoneNumber)"
      >
        <v-btn @click="postVerify('phone_number')" icon>
          <v-icon class="orange--text">send</v-icon>
        </v-btn>
      </v-flex>
      <v-flex
        xs2
        sm2
        md1
        lg1
        xl1
        v-if="useDetails.isPhoneNumberVerified  && !isShow &&useDetails.phoneNumber"
      >
        <v-btn icon>
          <v-icon class="green--text">done_outline</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="isShowemail==true || isShowphone==true">
      <v-flex xs12 sm12 md6 lg6 xl6>
        <v-text-field v-model="otp" type="text" :placeholder="profileInfoSection.OTP_placeholder"></v-text-field>
      </v-flex>
      <v-flex xs12 sm12 md1 lg1 xl1 style="margin-top: 32px;">
        <a v-if="isShowemail==true" href="#" @click="otpVerify('email')" style="float:right">
          <v-icon class="orange--text">send</v-icon>
        </a>
        <a v-if="isShowphone==true" href="#" @click="otpVerify('phone_number')" style="float:right">
          <v-icon class="orange--text">send</v-icon>
        </a>
      </v-flex>

      <v-flex xs12 sm12 md6 lg6 xl6 v-if="resenshow">
        <a v-if="isShowemail==true" href="#" @click.prevent="postVerify('email')">
          <p>{{profileInfoSection.Resend_OTP_Label}}</p>
        </a>
        <a v-if="isShowphone==true" href="#" @click.prevent="postVerify('phone_number')">
          <p>{{profileInfoSection.Resend_OTP_Label}}</p>
        </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import gettingHttpFunctions from "../../../services/utils/http-helper";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(VueMoment, {
  moment,
});
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
    // notverified() {
    //   var user = localStorage.getItem("embryo");
    //   var userData = JSON.parse(user);
    //   var useDetails = userData.user_data;
    //   if (!useDetails.isPhoneNumberVerified) {
    //     this.$snotify.warning("Verify phone number", {
    //       closeOnClick: false,
    //       pauseOnHover: false,
    //       timeout: 1000,
    //       showProgressBar: false,
    //     });
    //   }
    //   return true;
    // },
  },
  components: {
    Loading,
  },
  data() {
    return {
      useDetails: "",
      phone: "",
      email: "",
      details: "",
      addressadd: "",
      address: "",
      otp: "",
      isShowemail: "",
      isShowphone: "",
      shippingAddressData: "",
      httpRequestFunctions: "",
      cmsRequestFunctions: "",
      profileInfoSection: "",
      isShow: "",
      resenshow: "",
      iseditMail: false,
      iseditPhone: false,
      isResend: "",
      isLoading: false,
      fullPage: true,
    };
  },
  watch: {
    selectedLocale: function () {
      this.getData();
      this.readProfile();
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.httpRequestFunctions = gettingHttpFunctions();
    this.readProfile();
    this.getData();
  },
  methods: {
    getData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl:
          "11 Profile Information/11 Profile Information/11 Profile Information.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var profileInfoArea = self.cmsRequestFunctions.pluck(
              "Profile_Section",
              res.area_List
            );
            self.profileInfoSection = self.cmsRequestFunctions.getAllMapData(
              profileInfoArea[0].component
            );
          }
          //console.log(self.profileInfoSection);
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },

    editaddress() {
      this.$router.push({ path: "/account/address" });
    },
    readProfile: async function () {
      var self = this;
      self.isLoading = true;
      var user = localStorage.getItem("embryo");

      var userData = JSON.parse(user);
      if (!userData) {
        window.location = "/home";
      }
      var useDetails = userData.user_data;
      if (!useDetails.isPhoneNumberVerified) {
        this.$snotify.warning("Verify phone number", {
          closeOnClick: false,
          pauseOnHover: false,
          timeout: 1000,
          showProgressBar: false,
        });
      }
      self.useDetails = userData.user_data;
      // console.log(self.useDetails);
      self.phone = self.useDetails.phoneNumber;
      self.email = self.useDetails.email;
      // var userName = self.useDetails.loginId;
      // var filterValue =
      //   "type='Shipping Address' AND keyword12='" + userName + "'";
      // var allData = await self.cmsRequestFunctions.getDbDataTableValue(
      //   filterValue,
      //   "date1"
      // );
      // if (
      //   allData != undefined &&
      //   allData.data != undefined &&
      //   allData.status == 200
      // ) {
      //   self.shippingAddressData = allData.data.data;
      //   self.shippingAddressData.forEach((element) => {
      //     if (element.bool1 == true) self.addressadd = element.keyword4;
      //   });
      // } else {
      //   // console.log("error:", allData);
      //   self.shippingAddressData = "";
      // }
      self.isLoading = false;
    },

    // verify: async function (attribute) {
    //   var self = this;
    //   var config = {
    //     axiosConfig: {
    //       method: "GET",
    //       url: "getattributeverificationcode/" + attribute,
    //       isBarrerNeeded: true,
    //     },
    //   };
    //   console.log(config);

    //   var resp = await self.httpRequestFunctions.mainAxiosRequest(config);
    //   console.log(resp);
    //   if(resp !== undefined && resp.code === 200) {
    //     self.postVerify(attribute);
    //   }
    // },
    postVerify: async function (attribute) {
      try {
        var self = this;

        if (
          (attribute == "email" &&
            self.email !== undefined &&
            self.email !== "") ||
          (attribute != "email" &&
            self.phone !== undefined &&
            self.phone !== "")
        ) {
          self.isLoading = true;
          var value;
          if (attribute == "email") {
            var emailPat = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            var matchArray = self.email.match(emailPat);
            if (matchArray == null) {
              this.$snotify.warning(
                self.cmsRequestFunctions.getValidationMsgByCode("M010"),
                {
                  closeOnClick: false,
                  pauseOnHover: false,
                  timeout: 1000,
                  showProgressBar: false,
                }
              );
              self.isLoading = false;
              return false;
            }
          } else {
            // var phoneformat = /([+]?\d{1,2}[.-\s]?)?(\d{3}[.-]?){2}\d{4}/i;
            var phoneformat = /([+]?\d{5,8}[.-\s]?)?(\d{1}[.-]?){5}\d{0}/g;
            var match = self.phone.match(phoneformat);
            if (match == null) {
              this.$snotify.warning(
                self.cmsRequestFunctions.getValidationMsgByCode("M031"),
                {
                  closeOnClick: false,
                  pauseOnHover: false,
                  timeout: 1000,
                  showProgressBar: false,
                }
              );
              self.isLoading = false;
              return false;
            }
          }
          // var plussign = "+";
          // attribute == "email"
          //   ? (value = self.email)
          //   : self.phone.includes("+")
          //   ? (value = self.phone)
          //   : (value = plussign.concat(self.phone));
          var isValid = false;
          attribute == "email"
            ? (value = self.email)
            : self.phone.includes("+")
            ? (value = self.phone)
            : (isValid = true);

          if (isValid) {
            this.$snotify.warning(
              self.cmsRequestFunctions.getValidationMsgByCode("M30"),
              {
                closeOnClick: false,
                pauseOnHover: false,
                timeout: 1000,
                showProgressBar: false,
              }
            );
            self.isLoading = false;
            return;
          }

          var serviceData = {
            attributeList: [
              {
                attributeName: attribute,
                attributeValue: value,
              },
            ],
          };
          var config = {
            axiosConfig: {
              method: "POST",
              url: "updateandverifyattribute",
              data: serviceData,
              isBarrerNeeded: true,
            },
          };
          //console.log(config);
          var resp = await self.httpRequestFunctions.mainAxiosRequest(config);
          // console.log(resp);
          if (resp != undefined && resp.code == 200) {
            if (attribute == "email") {
              self.isShowemail = true;
              self.isShow = true;
              self.iseditMail = false;
            } else {
              self.isShowphone = true;
              self.isShow = true;
              self.iseditPhone = false;
            }
            if (self.resenshow) {
              self.resenshow = false;
            } else {
              setTimeout(() => {
                self.resendotp();
              }, 36000);
            }
            this.$snotify.success(resp.message, {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            });
            // if (resp != undefined && resp.code == 200) {
            // self.resenshow = true;
          }
          self.isLoading = false;
        } else {
          this.$snotify.warning(
            attribute == "email"
              ? self.cmsRequestFunctions.getValidationMsgByCode("M007")
              : self.cmsRequestFunctions.getValidationMsgByCode("M028"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    resendotp() {
      var self = this;
      self.resenshow = true;
    },
    otpVerify: async function (attribute) {
      try {
        var self = this;
        if (self.otp !== undefined && self.otp !== "") {
          self.isLoading = true;
          var config = {
            axiosConfig: {
              method: "GET",
              url: "verifyattribute/" + attribute + "/" + self.otp,
              isBarrerNeeded: true,
            },
          };

          var resp = await self.httpRequestFunctions.mainAxiosRequest(config);
          // console.log(resp);

          // var resp = await self.httpRequestFunctions.mainAxiosRequest(config);
          // console.log(resp);

          if (resp != undefined && resp.code == 200) {
            var user = localStorage.getItem("embryo");
            var useDetails = JSON.parse(user);
            var loginData = useDetails.user_data;
            if (attribute == "email") {
              self.isShowemail = false;

              loginData.isEmailVerified = true;
              loginData.email = self.email;
              localStorage.setItem(
                "embryo",
                JSON.stringify({ user_data: loginData })
              );
            } else {
              loginData.isPhoneNumberVerified = true;
              loginData.phoneNumber = self.phone;

              localStorage.setItem(
                "embryo",
                JSON.stringify({ user_data: loginData })
              );

              self.isShowphone = false;
            }

            self.isShow = false;
            this.$snotify.success("verified" + attribute, {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            });
            this.readProfile();
            //  window.location.reload();
          }
          self.isLoading = false;
        } else {
          this.$snotify.success(
            self.cmsRequestFunctions.getValidationMsgByCode("M029"),
            {
              closeOnClick: false,
              pauseOnHover: false,
              timeout: 1000,
              showProgressBar: false,
            }
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    edit(attribute) {
      var self = this;
      attribute === "email"
        ? (self.iseditMail = true)
        : (self.iseditPhone = true);
    },
  },
};
</script>

